/**
 * tracking/email.js
 *
 * Handles event tracking for email captures on site.
 * Fires: 1. FormViewed 2. Identify 3. FormSubmitted
 *
 */

(($) => {
	// Handles toggling of loading message.
	document.addEventListener('om.Html.append.after', function (event) {
		const campaignId = event.detail.Campaign.id;
		$(`.oim-loading-container.campaign--${campaignId}`).hide();
	});

	// Prevent OIM from loading fonts.
	document.addEventListener('om.Scripts.init', function (e) {
		e.detail.Scripts.enabled.fonts = false;
	});

	// Handle FormViewed and FormSubmitted
	document.addEventListener('om.Analytics.track', (e) => {
		const isSubmitted = 'conversion' === e.detail.Analytics.type;
		const campaignData = e.detail.Campaign;
		const eventPayload = {
			formType: 'CONTACT',
			formName: campaignData.name,
			formId: campaignData.id,
			captureType: 'OptinMonster',
			capturePlacement:
				campaignData.type === 'fullscreen'
					? 'Full Screen'
					: campaignData.type, // Cohesion expects "Full Screen"
		};

		if (isSubmitted) {
			const isCustomHTML = $(
				`.oim-campaign--${campaignData.id} form`
			).hasClass('custom-html-form');

			const formData = {};

			// With custom HTML, we get the data by targeting form selectors.
			if (isCustomHTML) {
				const inputs = $(campaignData.Form.inputs);
				const phoneInput = inputs.filter('#phone');
				const tcpaInput = inputs.filter('#tcpa-consent');

				if (phoneInput.length) {
					formData.phone = phoneInput.val().replace(/\D/g, '');
				}

				if (tcpaInput.length) {
					formData.hasTcpaConsent = tcpaInput.is(':checked');
				}
			} else {
				const emailInput = campaignData.Optin.data.fields.email;
				const nameInput = campaignData.Optin.data.fields.name;
				const phoneInput = campaignData.Optin.data.fields.phone;
				const tcpaInput =
					campaignData.Optin.data.fields[
						'FieldsElement--privacyText-checkbox'
					];

				if (emailInput) {
					formData.email = emailInput.toLowerCase();
				}

				if (nameInput) {
					formData.name = nameInput;
				}

				if (phoneInput) {
					formData.phone = phoneInput.replace(/\D/g, '');
				}

				if (tcpaInput) {
					formData.hasTcpaConsent = tcpaInput === 'on';
				}
			}

			const traits = {};
			const externalIds = [];

			// We only send Identify if we're asking for email.
			if (formData.email) {
				traits.email = formData.email;

				if (formData.name) {
					traits.name = formData.name;
				}

				if (formData.phone) {
					traits.phone = formData.phone;

					externalIds.push({
						id: formData.phone,
						type: 'phone',
						collection: 'users',
						encoding: 'none',
					});
				}

				// Fire Identify event only if email is set.
				// The userId property is a hash of the email. https://redventures.atlassian.net/wiki/spaces/IDM/pages/306480223/Identify
				sha256(formData.email).then(function (hashedEmail) {
					tagular('beam', {
						'@type': 'core.Identify.v1',
						traits,
						userId: hashedEmail,
						externalIds,
					});

					trackEmailFormEvents(true, eventPayload);
				});
			} else {
				trackEmailFormEvents(true, eventPayload);
			}

			// For phone captures, send the TCPA consent event.
			if (formData.hasTcpaConsent && formData.phone) {
				tagular(
					'beam',
					{
						'@type': 'core.integration.TcpaConsentCaptured.v1',
						acceptance: formData.hasTcpaConsent,
						phoneNumber: formData.phone,
						integrationContext: {
							clientId: campaignData.id,
							orderId: campaignData.name,
						},
						disclosureId: '',
					},
					false,
					false
				);
			}
		} else {
			trackEmailFormEvents(false, eventPayload);
		}
	});

	/**
	 * Tracks FormViewed/FormSubmitted events for email
	 *
	 * @param {boolean}     isSubmitted  Whether this is FormSubmitted or not.
	 * @param {HTMLElement} eventPayload Object containing the event properties.
	 */
	function trackEmailFormEvents(isSubmitted, eventPayload) {
		const formEvent = isSubmitted ? 'FormSubmitted' : 'FormViewed';
		tagular('beam', formEvent, {
			'@type': `redventures.usertracking.v3.${formEvent}`,
			formContext: {
				formType: eventPayload.formType,
				formName: eventPayload.formName,
				formId: eventPayload.formId,
			},
			captureContext: {
				captureType: eventPayload.captureType,
				capturePlacement: eventPayload.capturePlacement,
				valueProp: 'Newsletter',
				identityRequested: true,
			},
		});
	}

	function sha256(str) {
		// We transform the string into an arraybuffer.
		const buffer = new TextEncoder('utf-8').encode(str);
		return crypto.subtle.digest('SHA-256', buffer).then(function (hash) {
			return hex(hash);
		});
	}

	function hex(buffer) {
		const hexCodes = [];
		const view = new DataView(buffer);

		for (let i = 0; i < view.byteLength; i += 4) {
			// Using getUint32 reduces the number of iterations needed (we process 4 bytes each time)
			const value = view.getUint32(i);
			// toString(16) will give the hex representation of the number without padding
			const stringValue = value.toString(16);
			// We use concatenation and slice for padding
			const padding = '00000000';
			const paddedValue = (padding + stringValue).slice(-padding.length);
			hexCodes.push(paddedValue);
		}

		// Join all the hex strings into one
		return hexCodes.join('');
	}
})(jQuery);
